export default __webpack_public_path__ + "static/media/sa.ae901f0d.png";